import React from "react";
import { format, parseISO } from "date-fns";

function formatTime(iso) {
	try {
		return format(parseISO(iso), "dd/MM/yyyy HH:mm");
	} catch {
		return "";
	}
}

function ThreadMessage({ author, body, createdAt, isAgent }) {
	const initial = (author?.name || "?").charAt(0).toUpperCase();
	return (
		<div
			className={`flex gap-3 ${isAgent ? "flex-row-reverse text-right" : ""}`}
		>
			<span
				className={`flex size-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold ${
					isAgent
						? "bg-primary text-white"
						: "bg-default-200 text-default-700 dark:bg-default-700 dark:text-default-200"
				}`}
			>
				{initial}
			</span>
			<div
				className={`max-w-[85%] rounded-lg px-3 py-2 ${
					isAgent
						? "bg-primary/10 text-default-800 dark:text-default-100"
						: "bg-default-100 text-default-800 dark:bg-default-800 dark:text-default-100"
				}`}
			>
				<p className="mb-1 text-xs font-semibold">{author?.name}</p>
				<p className="whitespace-pre-wrap text-sm">{body}</p>
				<p className="mt-1 text-[10px] text-default-500">{formatTime(createdAt)}</p>
			</div>
		</div>
	);
}

export default function CommentThread({ comment, hideMain = false }) {
	if (!comment) return null;

	return (
		<div className="space-y-4">
			{!hideMain && (
				<ThreadMessage
					author={comment.author}
					body={comment.body}
					createdAt={comment.createdAt}
				/>
			)}
			{(comment.replies || []).map((reply) => (
				<ThreadMessage
					key={reply.id}
					author={reply.author}
					body={reply.body}
					createdAt={reply.createdAt}
					isAgent={reply.isAgent}
				/>
			))}
		</div>
	);
}
